if (!window.customElements.get('gz-protection-plan')) {
  class GzProtectionPlan extends HTMLElement {
    constructor() {
      super();
      this.product = JSON.parse(this.getAttribute("gz-product")) || null;
      this.protectionPlan = JSON.parse(this.getAttribute("gz-protection-plan")) || null;
      this.planSelected = JSON.parse(this.getAttribute("gz-plan-selected")) || false;
      this.checkbox = this.querySelector("#gz-protection-plan-checkbox");
      this.checkbox?.addEventListener("change", this.togglePlanSelection.bind(this));
      this.checkoutBtn = document.querySelector("button.cart__checkout-button");
    }

    connectedCallback() {
      // Add Protection Plan while product being added to cart
      subscribe(PUB_SUB_EVENTS.productAdded, async (event) => {
        this.isLoading(true);
      
        try {
          // Attempt to add product to cart
          await window.GzTheme.addProductToCart(event.itemAdded, this.protectionPlan.id, this.planSelected);
        } catch (error) {
          // Log the error to DataDog
          window.GzTheme.sendLogsToDataDog({
            error,
            message: 'Error adding product to cart from productAdded event',
            payload: {
              itemAdded: event.itemAdded,
              protectionPlanId: this.protectionPlan.id,
              planSelected: this.planSelected
            }
          });
          throw error;
        } finally {
          this.isLoading(false);
          window.location = window.routes.cart_url;
        }
      });
   
      // variantChange event - Reset protection plan checkbox
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        this.resetCheckbox();
      });
    }

    // Toggle protection plan checkbox - PDP 
    togglePlanSelection(event) {
      this.planSelected = event.target.checked;
    }

    // Reset protection plan checkbox - PDP
    resetCheckbox() {
      this.planSelected = false;
      if(this.checkbox) {
        this.checkbox.checked = false;
      }
    }

    isLoading(isLoading) {
      this.classList.toggle("loading", isLoading);
    
      if (this.checkoutBtn) {
        this.checkoutBtn.disabled = isLoading;
      }
    }
  }
  window.customElements.define('gz-protection-plan', GzProtectionPlan);
}